import React, { useState, useEffect } from "react";
import '../../sass/components/flexibleModules/_components.heroSectionWithImageAndVideo.scss';
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image";

const HeroSectionWithImageAndVideo = ({ data }) => {

    useEffect(() => {
        if (data.heroSectionVideoCheck === 'yes') {
            var scriptOne = document.createElement('script');
            scriptOne.src = `https://fast.wistia.com/embed/medias/${data.heroSectionVideoId}.jsonp`;
            scriptOne.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptOne);
            var scriptTwo = document.createElement('script');
            scriptTwo.src = 'https://fast.wistia.com/assets/external/E-v1.js';
            scriptTwo.async = 'async';
            document.getElementsByTagName('head')[0].appendChild(scriptTwo);
        }
    }, []);

    const [videoShow, setVideoShow] = useState(false);
    const showVideo = (val) => {
        setVideoShow(val);
    }

    const scrollToSection = () => {
        if (document.querySelector(".cp-heroSectionWithFormAndThumbnail")) {
            window.scrollTo({
                top: document.querySelector(".cp-heroSectionWithFormAndThumbnail").offsetTop - 10,
                left: 0,
                behavior: 'smooth'
            });
        }
    }

    return (
        <div className={`cp-heroSectionWithImageAndVideo l-graphicCheck${data.backgroundGraphic} ${data.overrideClass ? data.overrideClass : "l-noOverride"}`} style={{ backgroundColor: `${data.backgroundGraphic === 'no' && data.backgroundColor ? data.backgroundColor : ""}` }}>
            <div className="cp-heroSectionWithImageAndVideo__inner l--flex" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                <div className={`cp-heroSectionWithImageAndVideo__left ${!data.heroSectionImage ? "l--noImageOrVideo" : ""}`}>
                    {data.heroSectionHeader &&
                        <h1 style={{ color: `${data.backgroundGraphic === 'no' && data.textColor ? data.textColor : ""}` }}>{data.heroSectionHeader}</h1>
                    }
                    {data.heroSectionTeaser &&
                        <p style={{ color: `${data.backgroundGraphic === 'no' && data.textColor ? data.textColor : ""}` }} dangerouslySetInnerHTML={{ __html: data.heroSectionTeaser }} />
                    }
                    {data.heroSectionHeaderButtons &&
                        <div className="l-buttonWrap">
                            {data.heroSectionHeaderButtons.map((link, index) => (
                                <>
                                    {link.button ?
                                        <>
                                            {link.button.url === '#dra-form' &&
                                                <button onClick={scrollToSection} style={{ color: `${data.backgroundGraphic === 'no' && data.textColor ? data.textColor : ""}` }} key={index} className="l-button" dangerouslySetInnerHTML={{ __html: link.button.title }} />
                                            }
                                        </>
                                        :
                                        <>
                                            {link.button &&
                                                <a style={{ color: `${data.backgroundGraphic === 'no' && data.textColor ? data.textColor : ""}` }} key={index} className="l-button" href={link.button.url} target={link.button.target} dangerouslySetInnerHTML={{ __html: link.button.title }} />
                                            }
                                        </>
                                    }
                                </>
                            ))}
                        </div>
                    }
                </div>
                <div className="cp-heroSectionWithImageAndVideo__right">
                    {data.heroSectionVideoCheck === 'yes' ?
                        <button onClick={() => showVideo(true)}>
                            {data.heroSectionImage &&
                                <GatsbyImage image={getImage(data.heroSectionImage.gatsbyImage)} alt={data.heroSectionImage.altText} />
                            }
                        </button>
                        :
                        <>
                            {data.heroSectionImage &&
                                <GatsbyImage image={getImage(data.heroSectionImage.gatsbyImage)} alt={data.heroSectionImage.altText} />
                            }
                        </>
                    }
                </div>
            </div>
            {videoShow &&
                <div className="l-videoPopup">
                    <div className="l-videoPopup__inner">
                        {data.heroSectionVideoId ?
                            <div className={`wistia_embed wistia_async_${data.heroSectionVideoId} autoPlay=true`}>&nbsp;</div>
                            :
                            <>
                                {data.heroSectionVideoIdYoutube &&
                                    <iframe width="560" height="315" src={`https://www.youtube.com/embed/${data.heroSectionVideoIdYoutube}?autoplay=1&rel=0`} title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                                }
                            </>
                        }
                        <button className="cp-wistiaVideo__close" onClick={() => showVideo(false)}>
                            <StaticImage src="../../images/video-close-icon.svg" alt=""></StaticImage>
                        </button>
                    </div>
                    <button className="cp-wistiaVideo__closebg" onClick={() => showVideo(false)}>Close Video</button>
                </div>
            }
        </div>
    );
}

export default HeroSectionWithImageAndVideo;